import React, { useState } from 'react'
import '../radius/Radius.css'
import MapImg from '../../assets/Images/map-img.png'

const Radius = () => {
    const [radius, setRadius] = useState(1.5); // Initial radius value

  const handleSliderChange = (e) => {
    const newValue = e.target.value;
    setRadius(newValue);
  };

  return (
    <div className="radius-container">
    <div className="map-container">
      {/* Replace the src with a valid map image */}
      <img src={MapImg} alt="Map" className="map-image" />
      <div
        className="radius-circle"
        style={{
          width: `${radius * 40}px`, // Adjust size dynamically
          height: `${radius * 40}px`,
        }}
      ></div>
    </div>
    <div className="slider-container d-flex flex-wrap gap-2 align-items-center">
      <label htmlFor="radius-slider" className="radius-label w-100 text-start">
        Radius
      </label>
      <input
        type="range"
        id="radius-slider"
        min="0.5"
        max="10"
        step="0.1"
        value={radius}
        onChange={handleSliderChange}
      />
      <span id="radius-value">{radius}km</span>
    </div>
  </div>
  )
}

export default Radius
